var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11663 5.84506L3.41813 5.35202C4.18112 5.18856 4.84535 4.68559 5.24836 3.96614L7.06585 0.72148C7.6047 -0.240492 8.89529 -0.240494 9.4341 0.72148L11.2516 3.96614C11.6546 4.68559 12.3189 5.18856 13.0819 5.35202L15.3834 5.84506C16.4721 6.07831 16.8772 7.53281 16.0886 8.37749L14.1569 10.4466C13.4945 11.1561 13.2068 12.1785 13.3913 13.1668L13.7482 15.0781C13.9759 16.298 12.8079 17.2685 11.7767 16.7161L9.4788 15.4855C8.70449 15.0708 7.79551 15.0708 7.02116 15.4855L4.72334 16.7161C3.69206 17.2685 2.52407 16.298 2.75185 15.0781L3.10872 13.1668C3.29325 12.1785 3.0055 11.1561 2.34311 10.4466L0.411389 8.37749C-0.377192 7.53281 0.0278652 6.07831 1.11663 5.84506Z",
    fill: "url(#paint0_linear_150_145)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_145",
    x1: 8.25,
    y1: -2.5e-7,
    x2: 8.25,
    y2: 16.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B37FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.d82cef95b4315a890e2f349186926366.svg";
export { ForwardRef as ReactComponent };